import React from 'react';
import { Route } from 'react-router-dom';
import loadableModule from 'spark-views/main/loadableModule';
import Permission from 'spark-util/Permission';
import { paths } from './OverdueAckRoutes'

const OverdueAck = loadableModule(() => import('./index.js'));

const OverdueAckRoute = () => (
	<Permission requires="sm.overdueAckManagement">
		<Route path={paths.root} component={OverdueAck} />
	</Permission>
);

export default OverdueAckRoute;